import { RootState } from 'types';

// Granular selectors so components subscribe only to the fields they read,
// instead of re-rendering on every inboxPage mutation (e.g. the per-keystroke
// draft update or client-list churn from incoming messages).
export const selectSelectedClient = (state: RootState) =>
  state.inboxPage?.selectedClient ?? null;

export const selectSelectedClientWaNumber = (state: RootState) =>
  state.inboxPage?.selectedClient?.clientWaNumber;

export const selectSelectedClientId = (state: RootState) =>
  state.inboxPage?.selectedClient?.id;

export const selectSelectedClientIsLastMessage = (state: RootState) =>
  state.inboxPage?.selectedClient?.isLastMessage;

export const selectClientList = (state: RootState) =>
  state.inboxPage?.clientList;

export const selectFilteredClientList = (state: RootState) =>
  state.inboxPage?.filteredClientList;

export const selectFilterFetch = (state: RootState) =>
  state.inboxPage?.filterFetch;

export const selectIsLoadingMessages = (state: RootState) =>
  state.inboxPage?.isLoadingMessages;

export const selectIsFromMessageSearch = (state: RootState) =>
  state.inboxPage?.isFromMessageSearch;

export const selectHasMoreMessages = (state: RootState) =>
  state.inboxPage?.selectedClient?.hasMoreMessages ?? false;

export const selectIsLoadingMoreMessages = (state: RootState) =>
  state.inboxPage?.isLoadingMoreMessages ?? false;

export const selectDrafts = (state: RootState) => state.inboxPage?.drafts;

export const selectHasMoreClients = (state: RootState) =>
  state.inboxPage?.hasMoreClients ?? false;

export const selectIsLoadingMoreClients = (state: RootState) =>
  state.inboxPage?.isLoadingMoreClients ?? false;
